import { createSlice } from '@reduxjs/toolkit';

import { LoadingState } from '../../../../../types';
import { SLICE_NAME } from '../../../types';
import {
  fetchSocialMediaPerformancePosts,
  fetchSocialMediaPerformanceSummary,
} from './SocialMediaPerformance.thunks';
import { getCacheKey, SocialMediaPerformanceState } from './types';

const initialState: SocialMediaPerformanceState = {
  summary: null,
  summaryCacheKey: null,
  summaryLoadingState: LoadingState.IDLE,
  summaryError: null,

  posts: null,
  postsCacheKey: null,
  postsLoadingState: LoadingState.IDLE,
  postsError: null,
};

export const { reducer } = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // summary
    builder.addCase(
      fetchSocialMediaPerformanceSummary.pending,
      (state, action) => {
        state.summaryLoadingState = LoadingState.PENDING;
        state.summaryError = null;
        state.summaryCacheKey = getCacheKey(action.meta.arg);
      }
    );

    builder.addCase(
      fetchSocialMediaPerformanceSummary.fulfilled,
      (state, action) => {
        state.summaryLoadingState = LoadingState.FULFILLED;

        state.summary = action.payload;
      }
    );

    builder.addCase(
      fetchSocialMediaPerformanceSummary.rejected,
      (state, action) => {
        state.summaryLoadingState = LoadingState.REJECTED;
        state.summaryError = action.error;
      }
    );

    // posts
    builder.addCase(
      fetchSocialMediaPerformancePosts.pending,
      (state, action) => {
        state.postsLoadingState = LoadingState.PENDING;
        state.postsError = null;
        state.postsCacheKey = getCacheKey(action.meta.arg);
      }
    );

    builder.addCase(
      fetchSocialMediaPerformancePosts.fulfilled,
      (state, action) => {
        state.postsLoadingState = LoadingState.FULFILLED;

        state.posts = action.payload;
      }
    );

    builder.addCase(
      fetchSocialMediaPerformancePosts.rejected,
      (state, action) => {
        state.postsLoadingState = LoadingState.REJECTED;
        state.postsError = action.error;
      }
    );
  },
});
